// extracted by mini-css-extract-plugin
module.exports = {"textSmall":"textSectionEditor_textSmall__2yPwY","textMedium":"textSectionEditor_textMedium__OdWWn","textLarge":"textSectionEditor_textLarge__2NfVT"};
    if(module.hot) {
      // 1783592038750
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  